import { useDispatch, useSelector } from "react-redux";
import { SearchIcon } from "../../../../Utils/SvgIcons";
import { initialFilterStateDiagnostic } from "./helper";
import { useEffect } from "react";
import { GetServiceTypeAction, getDiagnosticCategoryAction } from "../../../../redux/actions/TestPackageCreationAction";
import { useState } from "react";
import { AddDiagnosticPopup } from "./AddDiagnosticPopup";
import Modal from "react-modal";
import CustomPagination from "../../../../common/CustomPagination";
import { GET_SERVICE_CREATION_DETAIL, getNetworkMenuId } from "../../../../Utils/types";
import { AddServicePopup } from "./AddServicePopup";
import { getDispatch } from "../../../../Utils/helper";

const DiagnosticPage = ({
  searchFilter,
  setSearchFilter,
  setIsRowData,
  isRowData,
}) => {
  const dispatch = useDispatch();
  const [isAddDiagnostic, setIsAddDiagnostic] = useState({
    isOpen: false,
    rowData: null,
  });
  const [isAddService, setIsAddService] = useState({
    isOpen: false,
    rowData: null,
  });
  const globalReducer = useSelector((state) => state?.globalReducer);
  const TestPackageCreationReducer = useSelector(
    (state) => state?.TestPackageCreationReducer
  );

  useEffect(() => {
    dispatch(getDiagnosticCategoryAction(searchFilter));
  }, []);

  const changeHandler = (name, value) => {
    setSearchFilter({ ...searchFilter, [name]: value });
  };

  const handleSearch = () => {
    setSearchFilter({ ...searchFilter, page: 1 });
    dispatch(getDiagnosticCategoryAction({ ...searchFilter, page: 1 }));
  };

  const handleClearFilter = () => {
    setSearchFilter(initialFilterStateDiagnostic);
    dispatch(getDiagnosticCategoryAction(initialFilterStateDiagnostic));
  };

  return (
    <div className="right-section" style={{ padding: "20px" }}>
      <div className="card staff-details-section">
        <div className="card-body">
          <h4> SKU Creation </h4>
          <div className="row-filter">
            <input
              type="text"
              placeholder="Service/Diagnostic/SKU"
              className="white-form-select"
              value={searchFilter?.diagnosticCategory}
              onChange={(e) =>
                changeHandler("diagnosticCategory", e.target.value)
              }
              onKeyPress={(event) => {
                if (event.key === "Enter") {
                  handleSearch(event);
                }
              }}
            />
            <select
              className="white-form-select"
              value={
                searchFilter?.type === "" ? "" : searchFilter?.type
              }
              onChange={(e) => changeHandler("type", e.target.value)}
            >
              <option value="">Select Type</option>
              <option value="Service">Service</option>
              <option value="Diagnostic">Diagnostic</option>
            </select>
            <select
              className="white-form-select"
              value={
                searchFilter?.isActive === null ? "" : searchFilter?.isActive
              }
              onChange={(e) => changeHandler("isActive", e.target.value)}
            >
              <option value="">Select Status</option>
              <option value="Y">Active</option>
              <option value="N">Inactive</option>
            </select>
            
            <div className="search" type="button" onClick={handleSearch}>
              <a className="sidebar-links">
                <SearchIcon />
                <span className="sidebar-link-text">Search</span>
              </a>
            </div>
            <div className="search" type="button" onClick={handleClearFilter}>
              <a className="sidebar-links">
                <span className="sidebar-link-text">Clear All</span>
              </a>
            </div>
          </div>
          <div className="row-results">
            <div className="d-flex gap-10">
              <select
                className="row-selectdropdown"
                value={searchFilter?.rows}
                onChange={(e) => {
                  setSearchFilter({
                    ...searchFilter,
                    page: 1,
                    rows: e.target.value,
                  });
                  dispatch(
                    getDiagnosticCategoryAction({
                      ...searchFilter,
                      rows: e.target.value,
                      page: 1,
                    })
                  );
                }}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
              </select>
              <p className="results">
                Total <span>{globalReducer?.getTotalCount}</span> results
              </p>
            </div>
            <div>
              {getNetworkMenuId()?.canEdit && (
                // <button
                //     className={`btn search__btn`}
                //     type="button"
                //     onClick={() =>
                //       setIsAddDiagnostic({ isOpen: true, rowData: null })
                //     }
                //   >
                //     <i className="fa-solid fa-plus pt-1 c-white"></i>&nbsp; Add
                //     Diagnostic
                //   </button>
                <>
                  <button
                    className="ascDescBtn search__btn ps-2 p-1 text-align-center"
                    style={{ textAlign: "center" }}
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    Create Service/Diagnostic &nbsp;
                  </button>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="advancePayoutDropdown"
                  >
                    <li>
                      <button
                        className="dropdown-item btn-border-bottom"
                        type="button"
                        onClick={() =>
                          setIsAddDiagnostic({ isOpen: true, rowData: null })
                        }
                      >
                        Add Diagnostic
                      </button>
                    </li>
                    <li>
                      <button
                        className="dropdown-item"
                        type="button"
                         onClick={() => {
                          setIsAddService({ isOpen: true, rowData: null })
                          getDispatch(GET_SERVICE_CREATION_DETAIL,null,dispatch)
                         }}
                      >
                        Add Service
                      </button>
                    </li>
                  </ul>
                </>
              )}
            </div>
          </div>
          <div className="table-responsive __custom__properties">
            <table className="table">
              <thead>
                <tr className="avanishtbl">
                  <th scope="col">Sr No.</th>
                  <th scope="col">Service/Diagnostic</th>
                  <th scope="col">Type</th>
                  <th scope="col">Service/Diagnostic ID</th>
                  <th scope="col">Active</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {TestPackageCreationReducer?.getDiagnosticsDetails?.map(
                  (ele, index) => {
                    return (
                      <tr key={index}>
                        <td>{ele?.rowNum}</td>
                        <td
                          className={`${
                            ele?.isActive === "Y"
                              ? "tbl-textgreen underline"
                              : "tbl-textred underline"
                          }`}
                          onClick={() => {
                            setIsRowData(ele);
                            
                          }}
                        >
                          {ele?.diagnosticCategory}
                        </td>
                        <td>{ele?.type}</td>
                        <td>{ele?.diagnosticCategoryId}</td>
                        <td>{ele?.isActive === "Y" ? "Yes" : "No"}</td>
                        <td
                          className="tbl-actionimg"
                          style={{
                            cursor: !getNetworkMenuId()?.canEdit
                              ? "default"
                              : "pointer",
                          }}
                          onClick={() => {
                            if (getNetworkMenuId()?.canEdit) {
                              if(ele?.type === "Diagnostics category"){
                                setIsAddDiagnostic({
                                  isOpen: true,
                                  rowData: ele,
                                });
                              } else if (ele?.type === "Services"){
                                setIsAddService({ isOpen: true, rowData: ele })
                                dispatch(GetServiceTypeAction(ele?.diagnosticCategoryId))
                              }
                             
                            }
                          }}
                        >
                          <img
                            src=".././images/edit-icon.png"
                            alt="exportsquare"
                          />
                        </td>
                      </tr>
                    );
                  }
                )}
              </tbody>
            </table>
          </div>
          <div className="pagination-row">
            {globalReducer?.getTotalCount !== 0 && (
              <CustomPagination
                totalCount={globalReducer?.getTotalCount}
                perPageData={searchFilter?.rows}
                searchFilter={searchFilter}
                setSearchFilter={setSearchFilter}
                apiCall={getDiagnosticCategoryAction}
              />
            )}
          </div>
          <Modal
            isOpen={isAddDiagnostic?.isOpen}
            className="modal-add-user-popup modal-role-user-popup modal-add-diagnostic"
            overlayClassName="overlay-history-popup network-z-index"
            ariaHideApp={false}
          >
            <AddDiagnosticPopup
              isAddDiagnostic={isAddDiagnostic}
              setIsAddDiagnostic={setIsAddDiagnostic}
              searchFilter={searchFilter}
              setSearchFilter={setSearchFilter}
            />
          </Modal>
          <Modal
            isOpen={isAddService?.isOpen}
            className="modal-add-user-popup modal-role-user-popup modal-role-add-service "
            overlayClassName="overlay-history-popup network-z-index"
            ariaHideApp={false}
          >
            <AddServicePopup
              isAddService={isAddService}
              setIsAddService={setIsAddService}
              searchFilter={searchFilter}
              setSearchFilter={setSearchFilter}
            />
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default DiagnosticPage;
